import { Link, Trans, useI18next } from "gatsby-plugin-react-i18next";
import React from "react";

export default function LanguageSwitcher() {
  const { languages, originalPath, language: currentLanguage } = useI18next();

  return (
    <ul className="navbar-nav flex-row flex-wrap ms-md-auto me-2">
      <li className="nav-item dropdown">
        <button className="btn btn-link nav-link dropdown-toggle" id="navbarDropdown" data-bs-toggle="dropdown" aria-expanded="false">
          <Trans>{currentLanguage}</Trans>
        </button>
        <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
          {languages
            .filter(x => x !== currentLanguage)
            .sort()
            .map(lng => (
              <li key={lng}>
                <Link className="dropdown-item" to={originalPath} language={lng}>
                  <Trans>{lng}</Trans>
                </Link>
              </li>
            ))}
        </ul>
      </li>
    </ul>
  );
}
